import React, { useState, useEffect } from "react";
import { X, History, Loader2, Brain } from "lucide-react";
import { query, collection, where, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../../config/firebase";
import { appId } from "../../config/constants";

const HistoryModal = ({ user, onClose, onSelectLog }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user) return;
        const q = query(
            collection(db, "artifacts", appId, "public", "data", "question_logs"),
            where("userId", "==", user.uid),
            orderBy("timestamp", "desc"),
            limit(50)
        );
        
        getDocs(q).then(snap => {
            setLogs(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            setLoading(false);
        }).catch(err => {
            console.error("Fetch history failed:", err);
            setLoading(false);
        });
    }, [user]);

    const formatTime = (timestamp) => {
        if (!timestamp) return "";
        const d = timestamp.toDate();
        const date = d.toLocaleDateString();
        const time = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
        return `${date} ${time}`;
    };

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in" onClick={onClose}>
            <div className="bg-white rounded-[2rem] w-full max-w-sm h-[80vh] flex flex-col shadow-2xl relative" onClick={e => e.stopPropagation()}>
                <div className="bg-slate-900 p-6 text-white relative shrink-0 rounded-t-[2rem]">
                    <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all"><X size={18}/></button>
                    <div className="flex items-center gap-3">
                        <History size={24} className="text-orange-400"/>
                        <h3 className="text-xl font-black tracking-wide">學習歷程</h3>
                    </div>
                </div>
                <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-slate-50">
                    {loading ? (
                        <div className="flex flex-col items-center justify-center h-full text-slate-400 gap-2">
                            <Loader2 className="animate-spin"/> 讀取中...
                        </div>
                    ) : logs.length === 0 ? (
                        <div className="flex flex-col items-center justify-center h-full text-slate-400 gap-2">
                            <History size={40} className="opacity-20"/> 尚無解題紀錄
                        </div>
                    ) : (
                        logs.map(log => (
                            <div key={log.id} onClick={() => onSelectLog(log)} className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm active:scale-95 transition-all cursor-pointer flex gap-4 items-start hover:border-orange-200">
                                {log.thumbnail ? (
                                    <img src={log.thumbnail} className="w-16 h-16 rounded-xl object-cover border border-slate-100 bg-slate-50 shrink-0" alt="thumb"/>
                                ) : (
                                    <div className="w-16 h-16 rounded-xl bg-slate-100 border border-slate-200 flex items-center justify-center shrink-0">
                                        <Brain size={24} className="text-slate-300"/>
                                    </div>
                                )}
                                <div className="flex-1 min-w-0">
                                    <div className="flex justify-between items-start mb-1">
                                        <span className="text-[10px] font-bold text-slate-400 bg-slate-50 px-2 py-0.5 rounded-full border border-slate-100">
                                            {formatTime(log.timestamp)}
                                        </span>
                                    </div>
                                    <p className="text-sm font-bold text-slate-700 line-clamp-2 mb-2">{log.questionText}</p>
                                    <div className="flex gap-1">
                                        {log.quizCount > 0 && <span className="text-[9px] bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded-md font-bold border border-blue-100">舉一反三</span>}
                                        {log.hasUsedConcept && <span className="text-[9px] bg-amber-50 text-amber-600 px-1.5 py-0.5 rounded-md font-bold border border-amber-100">重點整理</span>}
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default HistoryModal;
